// src/components/common/Select.jsx
// Reusable select component

import React from 'react';

const Select = ({
  label,
  icon,
  name,
  value,
  onChange,
  options = [],
  placeholder,
  error,
  required,
  disabled
}) => {
  // Normalize options to always be { value, label } shape,
  // so the component works whether you pass strings or objects.
  const normalizedOptions = options.map((opt) =>
    typeof opt === 'object' && opt !== null
      ? opt
      : { value: opt, label: opt }
  );

  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={name} className="block text-gray-700 font-semibold mb-1 dark:text-gray-200">
          {icon && <span className="mr-2">{icon}</span>}
          {label}
        </label>
      )}
      <select
        id={name}
        name={name}
        className={`neumorphic-input w-full ${error ? 'border-red-400' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      >
        <option value="" disabled>{placeholder || 'Select an option'}</option>
        {normalizedOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
};

export default Select;